import { render } from "./Scorers.vue?vue&type=template&id=46f89d22&scoped=true"
import script from "./Scorers.vue?vue&type=script&lang=js"
export * from "./Scorers.vue?vue&type=script&lang=js"

import "./Scorers.vue?vue&type=style&index=0&id=46f89d22&scoped=true&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f89d22"]])

export default __exports__